import { useRef } from 'react';
import { Button } from 'antd';
import { useLocation } from "react-router-dom";
import styles from './loginHead.module.scss'
import * as PromoteButtons from '../PromoteButtons';
import PayModal from '@view/compoents/payModal/payModal'

function LoggedHead(props) {
    const location = useLocation()

    const handleClick = (e) => {
        e.preventDefault()
        e.stopPropagation()
        props.onLogin()
    }

    const payChildRef = useRef(null);
    const openPayClick = () => {
        payChildRef.current.openrechargeClick()
    }

    return (
        <div className={styles.LoginHead}>
            <i></i>
            <div style={{ display: 'flex', gap: ".24rem" }}>
                <PromoteButtons.ServiceBtn />
                <PromoteButtons.NewUserBtn />
                <PromoteButtons.MembershipBtn onClick={openPayClick} />
                <Button type="primary" className={styles.btn_r} onClick={handleClick} >登录/注册</Button>
            </div>
            <PayModal ref={payChildRef}></PayModal>
        </div>

    )
}

export default LoggedHead